export default "__VITE_ASSET__fMHeGXMG__"